module.exports = __webpack_public_path__ + "static/media/golden_freddy.41c3a7ac.ogg";